import React from 'react';
import type { AfcSubmission, AfcSubmissionCandidate } from '@axiom/validation';

import { CandidateProposedRateUtil } from '../../../utils/candidate-proposed-rate-util';

export type CandidateSubmissionRateTypes = {
  candidateId: AfcSubmissionCandidate['id'];
  submission: AfcSubmission;
};

export const CandidateSubmissionRate = ({
  candidateId,
  submission,
}: CandidateSubmissionRateTypes) => {
  const rateData = CandidateProposedRateUtil.formatCandidateRate(
    candidateId,
    submission
  );

  if (typeof rateData === 'string') {
    return <span data-test="NO_RATE">{rateData}</span>;
  }

  const { rate, increment } = rateData;

  return (
    <span data-test="RATE">
      {rate}/{increment}
    </span>
  );
};
